import { checkoutFooterPortalId } from 'app/components/Core/Checkout/Footer'
import Form from 'app/components/Core/DeliveryContact/Form'
import { useMutation } from 'app/lib/hooks/useMutation'
import { RecordTypeEnum } from 'app/queries'
import * as rentalsCheckout from 'app/queries/Rentals/Checkout'
import React from 'react'

interface Props {
  rental_id: number
  contact_id: number
  onSuccess: (contact: IContact) => void
  onClose: () => void
}

const Update: React.FC<Props> = ({
  rental_id,
  contact_id,
  onSuccess: onUpdateSuccess,
  onClose
}) => {
  const { loading, execute } = useMutation(rentalsCheckout.UPDATE_DELIVERY_CONTACT, {
    recordType: RecordTypeEnum.rental,
    silentSuccess: true
  })

  const onSuccess = async (contact: IContact) => {
    await execute({ rentalId: rental_id, deliveryContactId: contact_id })
    onUpdateSuccess(contact)
  }

  return (
    <Form
      member={{ id: contact_id }}
      props={{ onSuccess, portalId: checkoutFooterPortalId, loading, onCancel: onClose }}
    />
  )
}

export default Update
